import { FC } from "react";
import { BRAND_INK, BRAND_ACCENT } from "../../theme/colors";

const WHITE = "#FFFFFF";

interface BrandMarkProps {
  /** "light" = teal-on-white (light backgrounds); "dark" = white-on-transparent (dark backgrounds) */
  variant?: "light" | "dark";
  size?: number;
  className?: string;
}

// The 1Markaz mark: a numeral "1" (stem + flag + base) with an accent dot standing in for
// its tittle — also reads as markaz's centre-point / a location-pin head. Colors are fixed to
// the app's real, already-shipped palette (app_fe/src/Assets/Constants.tsx), not per-theme.
const BrandMark: FC<BrandMarkProps> = ({ variant = "light", size = 28, className }) => {
  const ink = variant === "dark" ? WHITE : BRAND_INK;
  return (
    <svg
      viewBox="0 0 120 120"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label="1Markaz"
    >
      <rect x="50" y="36" width="20" height="56" rx="7" fill={ink} />
      <polygon points="34,54 50,36 50,52 40,60" fill={ink} />
      <rect x="32" y="90" width="56" height="14" rx="6" fill={ink} />
      <circle cx="60" cy="24" r="13" fill={BRAND_ACCENT} />
    </svg>
  );
};

export default BrandMark;
